/**
 * Arruma o que a pessoa digita no campo de atalho.
 *
 * O texto de ajuda mostra "/atalho" porque é assim que se usa no chat, e todo mundo
 * escreve a barra junto. A barra não entra no valor guardado — em vez de recusar com um
 * "use apenas letras, números e hífen", o campo simplesmente a engole.
 *
 * Acento vira a letra sem acento, e não some: jogar fora o "ç" transformaria "Recepção"
 * em "recepo", que não é atalho de coisa nenhuma.
 */
export function arrumarAtalho(bruto: string): string {
  return (
    bruto
      .toLowerCase()
      // Separa a letra do acento (NFD) e descarta só o acento.
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/^[/\s]+/, '')
      .replace(/\s+/g, '-')
      .replace(/[^a-z0-9-]/g, '')
      // Quem digita depressa produz "boas--vindas"; um hífen basta.
      .replace(/-{2,}/g, '-')
  );
}
